import { LanguageCode } from "../models";
import { fetchAuthenticated } from "../scripts/custom-fetch";

export async function getLanguageCodes() {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/language-codes`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as LanguageCode[];
}
